import { isPathLookupEdgeData } from '@ipfabric/utils';
import type { PacketDetailMouseEvent } from 'components/DeviceView/DeviceViewContent/PacketDetail/PacketDetail';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { unhighlightEdges } from '../pathLookup/unhighlightEdges';

export const pathLookupDetailNextButtonMouseLeave: GraphCommandFactory<
  PacketDetailMouseEvent
> = (cmdContext, dispatch) => (command) => {
  const foundEdge = cmdContext.getState().graph.edges[command.detailId];
  if (foundEdge === undefined || !isPathLookupEdgeData(foundEdge)) {
    return;
  }

  // Unhighlight outgoing edges from following node
  dispatch(unhighlightEdges, { edges: foundEdge.nextEdgeIds });
};
